import gql from 'graphql-tag';

const GET_PRESENTATION_JOBS = gql`
  query presentationJobs($projectId: Int!, $limit: Int) {
    presentationJobs(projectId: $projectId, limit: $limit) {
      jobId
      status
      requestedAt
      generatedAt
      downloadUrl
      projectName
      templateName
      filters
      progressPercent
      stepLabel
      durationMinutes
      isBlocked
    }
    queuedPresentationJobsCount
  }
`;

export default GET_PRESENTATION_JOBS;
